import { useState, useEffect, useCallback } from 'react';
import {
  checkForUpdate, dismissUpdate, applyWebUpdate, applyApkUpdate,
  openSiteFallback, CHECK_INTERVAL, APP_VERSION, isAPK,
} from '../../services/updateService';
import './UpdateNotification.css';

export default function UpdateNotification() {
  const [update, setUpdate] = useState(null);
  const [apkMode] = useState(() => isAPK());
  const [busy, setBusy] = useState(false);

  const runCheck = useCallback(async () => {
    const r = await checkForUpdate();
    if (r) setUpdate(r);
  }, []);

  useEffect(() => {
    const t1 = setTimeout(runCheck, 10_000);
    const t2 = setInterval(runCheck, CHECK_INTERVAL);
    const onVis = () => { if (document.visibilityState === 'visible') runCheck(); };
    const onOn  = () => runCheck();
    document.addEventListener('visibilitychange', onVis);
    window.addEventListener('online', onOn);
    return () => {
      clearTimeout(t1); clearInterval(t2);
      document.removeEventListener('visibilitychange', onVis);
      window.removeEventListener('online', onOn);
    };
  }, [runCheck]);

  if (!update) return null;

  const handlePrimary = async () => {
    setBusy(true);
    try {
      if (apkMode) await applyApkUpdate(update.apkUrl);
      else applyWebUpdate();
    } finally {
      setBusy(false);
    }
  };

  const primaryLabel = busy
    ? 'لطفاً صبر کنید…'
    : (apkMode ? 'دانلود نسخه جدید' : 'به‌روزرسانی');

  if (update.forceUpdate) {
    return (
      <div className="update-overlay" dir="rtl">
        <div className="update-modal">
          <div className="update-modal__icon">🚀</div>
          <h2 className="update-modal__title">به‌روزرسانی اجباری</h2>
          <p className="update-modal__text">
            نسخه‌ی جدید ({update.version}) منتشر شده است. برای ادامه، لطفاً به‌روزرسانی کنید.
          </p>
          {update.message && <p className="update-modal__message">{update.message}</p>}
          <p className="update-modal__current">نسخه‌ی شما: {APP_VERSION}</p>
          <button className="update-modal__btn" onClick={handlePrimary} disabled={busy}>
            {primaryLabel}
          </button>
          {apkMode && (
            <>
              <p className="update-modal__hint">اگر دکمه کار نکرد:</p>
              <button
                className="update-modal__btn update-modal__btn--secondary"
                onClick={openSiteFallback}
              >رفتن به سایت</button>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="update-banner" dir="rtl">
      <div className="update-banner__icon">🎉</div>
      <div className="update-banner__body">
        <div className="update-banner__title">نسخه‌ی جدید {update.version} موجود است</div>
        {update.message && <div className="update-banner__msg">{update.message}</div>}
      </div>
      <div className="update-banner__actions">
        <button
          className="update-banner__btn update-banner__btn--ghost"
          onClick={() => { dismissUpdate(update.version); setUpdate(null); }}
          disabled={busy}
        >بعداً</button>
        <button
          className="update-banner__btn update-banner__btn--primary"
          onClick={handlePrimary}
          disabled={busy}
        >{primaryLabel}</button>
      </div>
    </div>
  );
}